import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { AgreementsAutocomplete, Form } from "@shared/components";

export const PlanListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("subscription_plan_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("subscription_plan_admin.filters.agreement")}
        />
      </Grid>
    </Grid>
  );
});
